import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Link from '@mui/material/Link'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Box from '@mui/material/Box'

export default {
  overrides: {
    h1: {component: Typography, props: {gutterBottom: true, variant: 'h1'}},
    h2: {component: Typography, props: {gutterBottom: true, variant: 'h2'}},
    h3: {component: Typography, props: {gutterBottom: true, variant: 'h3'}},
    h4: {component: Typography, props: {gutterBottom: true, variant: 'h4'}},
    h5: {component: Typography, props: {gutterBottom: true, variant: 'h5'}},
    h6: {component: Typography, props: {gutterBottom: true, variant: 'h6'}},
    p: {
      component: Typography,
      props: {
        gutterBottom: true,
        variant: 'body1',
      },
    },
    a: {component: Link},
    hr: {
      component: Divider,
      props: {variant: 'middle', sx: {my: 4, pt: 1, mx: 0}},
    },
    ul: {
      component: List,
      props: {
        dense: true,
      },
    },
    ol: {
      component: Box,
      props: {
        dense: true,
        component: 'ol',
        sx: {
          '& > li': {
            listStyleType: 'decimal',
          },
        },
      },
    },
    li: {
      component: ListItem,
      props: {
        sx: {
          pl: 0,
        },
        dense: true,
      },
    },
  },
}
